<script>
import EditableTable from "./EditableTable.vue";
import { URL_TOOL_ALERT_IGNORE } from "api/commissionApi";
import { Api } from "api/commissionEnv";
const api = new Api();
const components = {
  "editable-table": EditableTable
};
let data = () => {
  return {
    loading: null,
    rows: [],
    columnNames: []
  };
};
const computed = {};
const props = {
  curArea: {
    type: String,
    default: ""
  }
};
const methods = {
  getUrl20() {
    return api.getUrl20(this.curArea, URL_TOOL_ALERT_IGNORE);
  },
  async save(rowIndex, columnIndex, value) {
    const url = this.getUrl20();
    const name = this.rows[rowIndex][0];
    const {
      data: {
        data: { updateRows }
      }
    } = await this.$http.post(url, { name, value });
    if (updateRows == 1) {
      let oldRows = [...this.rows];
      oldRows[rowIndex][columnIndex] = value;
      this.rows = oldRows;
    }
    return updateRows == 1;
  },
  onSave() {
    return this.save.bind(this);
  },
  async load() {
    if (this.loading !== this.curArea) {
      this.loading = this.curArea;
      this.columnNames = [];
      this.rows = [];
      const url = this.getUrl20();
      const {
        data: { data }
      } = await this.$http.get(url);

      if (data instanceof Array) {
        let keys = [{ name: "name", editable: false }, "value"];
        let values = data.map(o => [o.name, o.value]);
        this.columnNames = keys;
        this.rows = values;
      } else {
        alert(
          `From ${url} not get data required. \nPlease check url for alert_ignore`
        );
      }
    }
  }
};
function beforeUpdate() {
  this.load().catch(console.error);
}

function beforeMount() {
  this.load().catch(console.error);
}
export default {
  data,
  props,
  computed,
  methods,
  beforeMount,
  beforeUpdate,
  components
};
</script>

<template>
  <div>
    <span v-if="rows.length == 0">Please Wait, the data of {{curArea}} is loading.</span>
    <editable-table
      v-else
      :title="`${curArea} Alert Ignore List`.toUpperCase()"
      :column-names="columnNames"
      :rows="rows"
      :save="onSave()"
    />
  </div>
</template>

<style scoped>
div {
  display: flex;
  flex: 1;
  justify-content: center;
  background: rgb(219, 219, 217);
  padding: 2ex 0 2ex;
}
span {
  font: 3ex bold;
}
</style>



// WEBPACK FOOTER //
// AlertIgnore.vue?073ce9ec